import { Component, OnInit } from '@angular/core';
import { GlobalAlertService } from 'src/app/services/global-alert.service';
import { GlobalService } from 'src/app/services/global.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import Swal from "sweetalert2";;
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { Swiper, Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);
@Component({
  selector: 'app-ver-visita',
  templateUrl: './ver-visita.component.html',
  styleUrls: ['./ver-visita.component.scss']
})
export class VerVisitaComponent implements OnInit {
  idtecnico;
  departamentos: any[] = [];
  municipio: any[] = [];
  municipios: any[] = [];
  departamento = "Seleccione departamento...";
  texto = "Seleccione departamento...";
  texto1 = "Seleccione municipio...";
  clientClass: any;
  Historial = Array([]);
  Archivos = Array();
  banderaExtencion: boolean = false;
  whatsappProvider: boolean = false;
  replanteoData: any[] = [];
  srcImgid: any[] = [];
  srcImg;
  Photo: string = "/";
  fotoUrlid;
  evidence;
  ext;
  formData;
  Photoid;
  evidenceId;
  idEncuestador;
  Estados;
  usrId;
  updateM;
  updateF;
  photos: boolean = false;
  log: boolean = false;
  importance;
  maintDesc;
  imgsUrls = Array();
  techInfo: any[] = [];
  flagS: boolean = false;
  NameP;
  datosMantenimiento = Array([]);
  isRevised = false;
  openFlag = false;
  fotosTabla = new Object();
  rutaFoto;
  rutaFoto2;
  imgsSede: any[] = [];
  imgFlag: boolean = false
  nombretecnico;
  fechavisita;
  descripcion;
  estado;
  tipomantenimiento;
  nombre;
  nui;
  tipodoc;
  documento;
  telefono;
  sexo;
  correo;
  ocupacion;
  Depto = "Seleccione departamento...";
  Municipio = "Seleccione municipio...";
  Cod_Mun;
  Vereda;
  Latitud;
  Longitud;
  Altitud;
  proyecto;
  seccional
  Tipo;
  Uso_Predio;
  Posesion;
  Estrato;
  fotoUrl = '';
  Medidor;
  SerialMedidor;
  MarcaMedidor;
  Fotovoltaico;
  Gabinete;
  Paneles;
  SPT;
  EstadoTarjetaNFC;
  Inversor;
  ControladorCargaMPPT;
  Bateria;
  Protecciones;
  Soportes;
  Instalaciones;
  TarjetaNFC;
  Marca_Medidor;
  ReferenciaM;
  NumMedidor;
  ReInicial;
  photosFirmas;
  Observaciones1;
  Observaciones2;
  call: boolean = false;
  call1: boolean = true;
  call2: boolean = true;
  call3: boolean = true;
  call4: boolean = true;
  call5: boolean = true;
  call6: boolean = true;
  call7: boolean = true;
  call8: boolean = true;
  call9: boolean = true;
  call10: boolean = true;
  call11: boolean = true;
  edit: boolean = false;
  edit1: boolean = false;
  edit2: boolean = false;
  edit3: boolean = false;
  edit4: boolean = false;
  edit5: boolean = false;
  edit6: boolean = false;
  edit7: boolean = false;
  edit8: boolean = false;
  imgBande1: boolean = false
  imgBande2: boolean = false
  imgBande3: boolean = false
  imgBande4: boolean = false
  imgBande5: boolean = false
  imgBande1f: boolean = false
  imgBande2f: boolean = false
  imgBande3f: boolean = false
  imgBande4f: boolean = false
  imgBande5f: boolean = false
  imgBande6f: boolean = false
  imgBandemf1: boolean = false
  imgBandemf2: boolean = false
  imgBandemf3: boolean = false
  A1 = new Array();
  A2 = new Array();
  A3 = new Array();
  A4 = new Array();
  A5 = new Array();
  F1 = new Array();
  F2 = new Array();
  F3 = new Array();
  F4 = new Array();
  F5 = new Array();
  F6 = new Array();
  MF1 = new Array();
  MF2 = new Array();
  MF3 = new Array();
  foto1: "data:image/jpeg;base64,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"
  oto2: 'data:image/jpeg;base64,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'


  constructor(public global: GlobalService, public ruta: Router, private spinner: NgxSpinnerService,
    public alerta: GlobalAlertService, private modalService: NgbModal, private router: Router) {
    this.global.initData();
  }


  ngOnInit(): void {
    this.spinner.show();
    this.clientClass = this.global.CLIENTDATALIWA;
    if (this.global.Id_Mantenimiento == undefined || this.global.Id_Mantenimiento == '') {
      this.ruta.navigateByUrl('/visitas');
    } else {
      this.openFlag = true;
      console.log("ESTE ES EL QUE VAMOS ", this.global.Id_Mantenimiento);
      const pdata3 = { option: 'insertar2', texto: "SELECT * FROM db_liwa.Tecnico  WHERE `instalMant` = '" + this.global.Id_Mantenimiento[0] + "';" };
      this.global.consultar(pdata3, async (err, response3) => {
        console.log("Datos Manten", response3);
        const respuesta = await response3
        if (respuesta.length > 0) {
          this.datosMantenimiento = respuesta;
          this.idtecnico = this.datosMantenimiento[0][1];
          this.nombre = this.datosMantenimiento[0][6];
          this.tipodoc = this.datosMantenimiento[0][7];
          this.documento = this.datosMantenimiento[0][8];
          this.telefono = this.datosMantenimiento[0][9];
          this.sexo = this.datosMantenimiento[0][10];
          this.correo = this.datosMantenimiento[0][11];
          this.ocupacion = this.datosMantenimiento[0][12];
          this.proyecto = this.datosMantenimiento[0][3];
          this.seccional = this.datosMantenimiento[0][4];
          this.Depto = this.datosMantenimiento[0][13];
          this.Municipio = this.datosMantenimiento[0][14];
          this.Cod_Mun = this.datosMantenimiento[0][15];
          this.Vereda = this.datosMantenimiento[0][16];
          this.Latitud = parseFloat(this.datosMantenimiento[0][17]);
          this.Longitud = parseFloat(this.datosMantenimiento[0][18]);
          this.Altitud = parseFloat(this.datosMantenimiento[0][19]);
          this.Tipo = this.datosMantenimiento[0][20];
          this.Uso_Predio = this.datosMantenimiento[0][21];
          this.Posesion = this.datosMantenimiento[0][22];
          this.Estrato = this.datosMantenimiento[0][23];
          this.Medidor = this.datosMantenimiento[0][24];
          this.SerialMedidor = this.datosMantenimiento[0][26];
          this.MarcaMedidor = this.datosMantenimiento[0][25];
          this.Fotovoltaico = this.datosMantenimiento[0][27];
          this.Gabinete = this.datosMantenimiento[0][28];
          this.Paneles = this.datosMantenimiento[0][29];
          this.SPT = this.datosMantenimiento[0][30];
          this.EstadoTarjetaNFC = this.datosMantenimiento[0][31];
          this.Inversor = this.datosMantenimiento[0][32];
          this.ControladorCargaMPPT = this.datosMantenimiento[0][33];
          this.Bateria = this.datosMantenimiento[0][34];
          this.Protecciones = this.datosMantenimiento[0][35];
          this.Soportes = this.datosMantenimiento[0][37];
          this.Instalaciones = this.datosMantenimiento[0][36]
          this.TarjetaNFC = this.datosMantenimiento[0][38];
          this.Marca_Medidor = this.datosMantenimiento[0][40];
          this.ReferenciaM = this.datosMantenimiento[0][41].toString();
          this.NumMedidor = this.datosMantenimiento[0][42].toString();
          this.ReInicial = this.datosMantenimiento[0][43].toString();
          this.Observaciones1 = this.datosMantenimiento[0][44].toString();
          this.Observaciones2 = this.datosMantenimiento[0][45].toString();

          this.searchMunicipalities(this.Depto);
          this.isRevised = true;

          this.A1 = new Array();
          this.A2 = new Array();
          this.A3 = new Array();
          this.A4 = new Array();
          this.A5 = new Array();
          this.F1 = new Array();
          this.F2 = new Array();
          this.F3 = new Array();
          this.F4 = new Array();
          this.F5 = new Array();
          this.F6 = new Array();
          this.MF1 = new Array();
          this.MF2 = new Array();
          this.MF3 = new Array();
          const pdata4 = { option: 'insertar2', texto: "SELECT `Id_FotoT`, `Rutaserver`, estado, `Id_Encuesta`, `Id_Encuestador` FROM db_liwa.Fotos_Tecnico WHERE `Id_Encuesta` = '" + this.datosMantenimiento[0][1] + "' AND IsDelete = 0;" };
          this.global.consultar(pdata4, async (err4, response4) => {
            console.log("FOTOS", response4);
            this.idEncuestador = response4[0][4];
            for (let a = 0; a < response4.length; a++) {
              if (response4[a][2] == "1") {
                this.A1.push(response4[a]);
                this.imgBande1 = true;
              }
              if (response4[a][2] == "2") {
                this.A2.push(response4[a]);
                this.imgBande2 = true;
              }
              if (response4[a][2] == "3") {
                this.A3.push(response4[a]);
                this.imgBande3 = true;
              }
              if (response4[a][2] == "4") {
                this.A4.push(response4[a]);
                this.imgBande4 = true;
              }
              if (response4[a][2] == "5") {
                this.A5.push(response4[a]);
                this.imgBande5 = true;
              }
              if (response4[a][2] == "1f") {
                this.F1.push(response4[a]);
                this.imgBande1f = true;
              }
              if (response4[a][2] == "2f") {
                this.F2.push(response4[a]);
                this.imgBande2f = true;
              }
              if (response4[a][2] == "3f") {
                this.F3.push(response4[a]);
                this.imgBande3f = true;
              }
              if (response4[a][2] == "4f") {
                this.F4.push(response4[a]);
                this.imgBande4f = true;
              }
              if (response4[a][2] == "5f") {
                this.F5.push(response4[a]);
                this.imgBande5f = true;
              }
              if (response4[a][2] == "6f") {
                this.F6.push(response4[a]);
                this.imgBande6f = true;
              }
              if (response4[a][2] == "MF1") {
                this.MF1.push(response4[a]);
                this.imgBandemf1 = true;
              }
              if (response4[a][2] == "MF2") {
                this.MF2.push(response4[a]);
                this.imgBandemf2 = true;
              }
              if (response4[a][2] == "MF3") {
                this.MF3.push(response4[a]);
                this.imgBandemf3 = true;
              }
            }
            const pdataF = {
              option: "insertar2",
              texto: `SELECT rutaserver, Id_Foto_Firma FROM db_liwa.fotos_firma WHERE Id_Formulario = '${this.datosMantenimiento[0][1]}' AND IsDelete = 0;`,
            };
            this.global.consultar(pdataF, async (err1, response1) => {
              // console.log(response1, "estetetetttetete")
              this.photosFirmas = await response1;
              this.spinner.hide();
            });
            // const pdata5 = { option: 'insertar2', texto: "SELECT Rutaserver, estado FROM db_liwa.Fotos_Tecnico WHERE Id_Encuesta = '"+this.datosMantenimiento[0][1]+"' AND estado NOT LIKE '%f' "};
            //   this.global.consultar(pdata5, async (err2,response5) => {
            //     this.Archivos = await response5;
            //     this.Archivos.length > 0 ? this.flagS = true : this.flagS = false
            //     this.spinner.hide()
            //     console.log("ARCHIVOS", pdata5)
            // });
          })
        } else {
          this.alerta.descErr(
            "Lastimosamente el registro aun no se encuentra!"
          );
          this.ruta.navigateByUrl('/visitas');
        }

      });
      const pdata = { option: 'visitas-visita', mantenimiento: this.global.Id_Mantenimiento[0] };
      this.global.consultar(pdata, async (err, response) => {
        this.techInfo = await response;
        console.log(this.techInfo, 'informacion del tecnico')
        this.nombretecnico = this.techInfo[0][0];
        this.fechavisita = this.techInfo[0][1];
        this.descripcion = this.techInfo[0][2];
        this.estado = this.techInfo[0][3];
        this.tipomantenimiento = this.techInfo[0][4];
      });
      const pdata1 = { option: 'Update_mantenimiento', mantenimiento: this.global.Id_Mantenimiento[0] };
      this.global.consultar(pdata1, async (err, response) => {
        console.log(await response, "iformacion Update mat")

        this.Historial = await response.length > 0 ? response : [['no registra']]
      });
      const pdata2 = { option: 'insertar2', texto: "SELECT NUI FROM db_liwa.AOM WHERE `Id_Encuesta` = '" + this.global.Id_Mantenimiento[1] + "';" };
      this.global.consultar(pdata2, async (err, response) => {
        console.log(await response, "informacion Nui")

        this.nui = response[0][0];
      });
      const pdata4 = { option: 'estados_visitas' };
      this.global.consultar(pdata4, async (err, response) => {
        this.Estados = response;
      })
      this.global.returnProvinces().subscribe((response) => {
        console.log(response, "miconsole");
        let deptos: any[] = [];
        this.municipio = response;
        for (let i = 0; i < response.length; i++) {
          deptos.push(response[i].departamento);
        }
        this.departamentos = deptos.filter((element, index) => {
          return deptos.indexOf(element) === index;
        });
      });
    }
  }


  // dataURItoBlob(dataURI) {
  //   const byteString = window.atob(dataURI);
  //   const arrayBuffer = new ArrayBuffer(byteString.length);
  //   const int8Array = new Uint8Array(arrayBuffer);
  //   for (let i = 0; i < byteString.length; i++) {
  //     int8Array[i] = byteString.charCodeAt(i);
  //   }
  //   const blob = new Blob([int8Array], { type: 'image/jpeg' });
  //   return blob;
  // }
  // loadPhoto() {
  //   this.updateM = moment().unix();
  //   if (this.photos == false) {
  //     this.actualizar();
  //   } else {
  //     this.spinner.show();
  //     setTimeout(() => {
  //       this.updateF = this.global.Id_Usuario + '_' + moment().unix();
  //       let con1 = 0;
  //       let con2 = 0;

  //       for (let i = 0; i < this.srcImg.length; i++) {
  //         con1++;
  //         console.log('Foto #' + i, this.srcImg[i]);
  //         const FOTOO = this.srcImg[i].slice(23, this.srcImg[i].length);
  //         this.updateF = i + '_' + moment().unix();
  //         const imageName = i + '-' + moment().unix() + '.jpg';
  //         const imageBlob = this.dataURItoBlob(FOTOO);
  //         const imageFile = FOTOO;
  //         const data = new FormData();
  //         console.log(imageFile, imageBlob);
  //         data.append('image', imageFile);
  //         data.append('nombre', imageName);
  //         data.append('ruta', this.updateF);
  //         $.ajax({
  //           url: 'https://fotos.engenius.com.co/subir_archivo_Mantenimiento.php',
  //           type: 'post',
  //           dataType: 'json',
  //           data,
  //           processData: false,
  //           contentType: false
  //         }).then((data1) => {
  //           console.log(data, data1);
  //           this.imgsUrls[i] = data1;
  //           con2++;
  //           if (this.imgsUrls[i] == 'BADEXT' || this.imgsUrls[i] == null || this.imgsUrls[i] == undefined || this.imgsUrls[i] == '' || this.imgsUrls[i] == 'NULL') {
  //             this.alerta.descErr('Error al subir la foto, verifique nuevamente');
  //           } else {
  //             const query = 'REPLACE INTO db_liwa.Maintenance_Update_Files (Id_FileM,Id_Maintenance,Id_Maintenance_Update,NameFile,TypeFile,File,IsDelete,IsActive)' +
  //               ' VALUES (\'' +
  //               this.updateF + '\',\'' +
  //               this.usrId + '\',\'' +
  //               this.updateM + '\',\'' +
  //               imageName + '\',\'' +
  //               'jpg' + '\',\'' +
  //               data1 + '\',\'' +
  //               0 + '\',\'' +
  //               1 + '\');';
  //             const pdata1 = { option: 'insertar', texto: query };
  //             this.global.consultar(pdata1, (err, response) => {
  //               console.log(response, query);
  //               if (err == null && response == true) {
  //                 this.spinner.hide();
  //                 this.ruta.navigateByUrl('/visitas');
  //                 this.actualizar();
  //               } else {
  //                 this.alerta.descErr('Error, verifique nuevamente que no hayan campos vacíos');
  //               }
  //             });
  //             // goto crear ticket
  //             if (con1 == con2 && con2 == this.srcImg.length) {

  //             }
  //           }
  //         });
  //       }

  //     }, 400);

  //   }
  // }

  modal(content, ruta, ruta2) {
    if (ruta2) {
      this.rutaFoto = "https://www.php.engenius.com.co/" + ruta
      this.rutaFoto2 = "https://www.php.engenius.com.co/" + ruta2
      this.modalService.open(content, { ariaLabelledBy: 'modal-vinculate' }).result.then((result) => {
        // this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
    else {
      this.rutaFoto = "https://www.php.engenius.com.co/" + ruta
      this.modalService.open(content, { ariaLabelledBy: 'modal-vinculate' }).result.then((result) => {
        // this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }

  }
  actualizar() {
    const query3 = 'REPLACE INTO db_liwa.Maintenance_Update (Id_MaintenanceU,Id_Maintenance,Id_User,Date,Description,Updates,IsDelete,IsActive)' +
      ' VALUES (\'' +
      this.updateM + '\',\'' +
      this.usrId + '\',\'' +
      this.global.Id_Usuario + '\',\'' +
      moment().format('YYYY-MM-DD HH:mm:ss') + '\',\'' +
      this.maintDesc + '\', \'' +
      this.importance + '\',\'' +
      0 + '\',\'' +
      1 + '\');';
    const pdata3 = { option: 'insertar', texto: query3 };
    this.global.consultar(pdata3, (err3, response3) => {
      console.log(response3, query3);
      if (err3 == null && response3 == true) {
        this.alerta.descValid('La visita de mantenimiento se actualizó con éxito');
        this.ngOnInit();
      } else {
        console.log(err3);
      }
    });
    this.enviarcorreo();
    this.clear();
  }
  clear() {
    this.importance = "";
    this.maintDesc = "";
    this.srcImg = [];
  }
  enviarcorreo() {
    // console.log('importance', this.importance);
    const pdata9 = { option: 'mailVisitaA', mantenimiento: this.usrId, texto: this.importance, user: this.global.USERDATALIWA[8], novedad: this.maintDesc };
    this.global.consultar(pdata9, (err2, response2) => {
      // console.log('Datos correo', response2);
    });
  }
  openFormtoUpdate(content) {
    this.usrId = this.global.Id_Mantenimiento;
    this.modalService.open(content, { ariaLabelledBy: 'modal-updateVisit' }).result.then((result) => {
      // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  verFoto() {
    this.router.navigateByUrl('https://www.foodiesfeed.com/wp-content/uploads/2021/01/fried-egg-and-guacamole-sandwiches-819x1024.jpg.webp')
  }
  formatt(item) {
    return moment(item).format('YYYY/MM/DD HH:MM:SS')
  }
  searchMunicipalities(depto) {
    this.spinner.show();
    let muni: any[] = [];
    // setTimeout(() => {
    for (let i = 0; i < this.municipio.length; i++) {
      if (depto == this.municipio[i].departamento) {
        muni.push(this.municipio[i].municipio);
      } else {
        continue;
      }
    }
    this.municipios = muni;
    this.spinner.hide();
    // }, 600);
  }
  editModule(numb: number) {
    switch (numb) {
      case 0:
        this.edit = !this.edit;
        break;
      case 1:
        this.edit1 = !this.edit1;
        break;
      case 2:
        this.edit2 = !this.edit2;
        break;
      case 3:
        this.edit3 = !this.edit3;
        break;
      case 4:
        this.edit4 = !this.edit4;
        break;
      case 5:
        this.edit5 = !this.edit5;
        break;
      case 6:
        this.edit6 = !this.edit6;
        break;
      case 7:
        this.edit7 = !this.edit7;
        break;

      default:
        break;
    }
  }

  animatedTab(numbr: number) {
    switch (numbr) {
      case 0:
        this.call = !this.call;
        break;
      case 1:
        this.call1 = !this.call1;
        break;
      case 2:
        this.call2 = !this.call2;
        break;
      case 3:
        this.call3 = !this.call3;
        break;
      case 4:
        this.call4 = !this.call4;
        break;
      case 5:
        this.call5 = !this.call5;
        break;
      case 6:
        this.call6 = !this.call6;
        break;
      case 7:
        this.call7 = !this.call7;
        break;
      case 8:
        this.call8 = !this.call8;
        break;
      case 9:
        this.call9 = !this.call9;
        break;
      case 10:
        this.call10 = !this.call10;
        break;
      case 11:
        this.call11 = !this.call11;
        break;

      default:
        break;
    }
  }


  confirmEdit(num: number) {
    switch (num) {
      case 1:
        if (
          this.nombre == undefined || this.nombre == null ||
          this.tipodoc == undefined || this.tipodoc == null ||
          this.documento == undefined || this.documento == null ||
          this.telefono == undefined || this.telefono == null ||
          this.sexo == undefined || this.sexo == null ||
          this.correo == undefined || this.correo == null ||
          this.ocupacion == undefined || this.ocupacion == null
        ) {
          this.alerta.descErr("Verifique que no hayan campos vacíos");
          this.edit1 = false;
        } else {
          this.spinner.show();
          // setTimeout(() => {
          try {
            const query1 =
              "UPDATE db_liwa.Tecnico SET " +
              "nombre = " +
              "'" +
              this.nombre +
              "'," +
              "tipoDoc = " +
              "'" +
              this.tipodoc +
              "'," +
              "numeroDoc = " +
              "'" +
              this.documento +
              "'," +
              "telefono = " +
              "'" +
              this.telefono +
              "'," +
              "sexo = " +
              "'" +
              this.sexo +
              "'," +
              "email = " +
              "'" +
              this.correo +
              "'," +
              "ocupacion = " +
              "'" +
              this.ocupacion +
              "'" +
              " WHERE Id_Encuesta =" +
              "'" +
              this.idtecnico +
              "';";
            const pdata1 = { option: "insertar", texto: query1 };
            console.log(pdata1);
            this.global.consultar(pdata1, async (err, response) => {
              console.log(response, query1);
              if ((await response)) {
                this.alerta.descValid("Los datos se actualizaron con éxito!");
                this.ngOnInit();
                this.edit1 = false;
                this.spinner.hide();
              } else if ((await response == null) || (await response == undefined)) {
                this.alerta.descErr();
                this.edit1 = false;
                this.spinner.hide();
              }
            });
          } catch (e) {
            console.log(e);
          }
          // }, 600);
        }
        break;
      case 3:
        if (
          this.Depto == undefined || this.Depto == null ||
          this.Municipio == undefined || this.Municipio == null ||
          this.Cod_Mun == undefined || this.Cod_Mun == null ||
          this.Vereda == undefined || this.Vereda == null ||
          this.Latitud == undefined || this.Latitud == null ||
          this.Longitud == undefined || this.Longitud == null ||
          this.Altitud == undefined || this.Altitud == null
        ) {
          this.alerta.descErr("Verifique que no hayan campos vacíos");
          this.edit3 = false;
        } else {
          this.spinner.show();
          // setTimeout(() => {
          try {
            const query3 =
              "UPDATE db_liwa.Tecnico SET " +
              "depto = " +
              "'" +
              this.Depto +
              "'," +
              "municipio = " +
              "'" +
              this.Municipio +
              "'," +
              "codmuni = " +
              "'" +
              this.Cod_Mun +
              "'," +
              "vereda = " +
              "'" +
              this.Vereda +
              "'," +
              "Latitud = " +
              "'" +
              this.Latitud +
              "'," +
              "Longitud = " +
              "'" +
              this.Longitud +
              "'," +
              "Altitud = " +
              "'" +
              this.Altitud +
              "'" +
              " WHERE Id_Encuesta =" +
              "'" +
              this.idtecnico +
              "';";
            const pdata3 = { option: "insertar", texto: query3 };
            // console.log(pdata1);
            this.global.consultar(pdata3, async (err, response) => {
              // console.log(response, query);
              if ((await response)) {
                this.alerta.descValid("Los datos se actualizaron con éxito!");
                this.ngOnInit();
                this.edit3 = false;
                this.spinner.hide();
              } else if ((await response == null) || (await response == undefined)) {
                this.alerta.descErr();
                this.edit3 = false;
                this.spinner.hide();
              }
            });
          } catch (e) {
            console.log(e);
          }
          // }, 600);
        }

        break;
      case 4:
        if (this.Tipo == undefined || this.Tipo == null) {
          this.alerta.descErr("Verifique que no hayan campos vacíos");
          this.edit4 = false;
        } else {
          this.spinner.show();
          // setTimeout(() => {
          try {
            const query4 =
              "UPDATE db_liwa.Tecnico SET " +
              "tipo = " +
              "'" +
              this.Tipo +
              "'" +
              " WHERE Id_Encuesta =" +
              "'" +
              this.idtecnico +
              "';";
            const pdata4 = { option: "insertar", texto: query4 };
            // console.log(pdata1);
            this.global.consultar(pdata4, async (err, response) => {
              // console.log(response, query);
              if ((await response)) {
                this.alerta.descValid("Los datos se actualizaron con éxito!");
                this.ngOnInit();
                this.edit4 = false;
                this.spinner.hide();
              } else if ((await response == null) || (await response == undefined)) {
                this.alerta.descErr();
                this.edit4 = false;
                this.spinner.hide();
              }
            });
          } catch (e) {
            console.log(e);
          }
          // }, 600);
        }
        break;
      case 5:
        if (
          this.Uso_Predio == undefined || this.Uso_Predio == null ||
          this.Posesion == undefined || this.Posesion == null ||
          this.Estrato == undefined || this.Estrato == null
        ) {
          this.alerta.descErr("Verifique que no hayan campos vacíos");
          this.edit5 = false;
        } else {
          this.spinner.show();
          // setTimeout(() => {
          try {
            const query5 =
              "UPDATE db_liwa.Tecnico SET " +
              "usopredio = " +
              "'" +
              this.Uso_Predio +
              "'," +
              "propio = " +
              "'" +
              this.Posesion +
              "'," +
              "estrato = " +
              "'" +
              this.Estrato +
              "'" +
              " WHERE Id_Encuesta =" +
              "'" +
              this.idtecnico +
              "';";
            const pdata5 = { option: "insertar", texto: query5 };
            // console.log(pdata1);
            this.global.consultar(pdata5, async (err, response) => {
              // console.log(response, query);
              if ((await response)) {
                this.alerta.descValid("Los datos se actualizaron con éxito!");
                this.ngOnInit();
                this.edit5 = false;
                this.spinner.hide();
              } else if ((await response == null) || (await response == undefined)) {
                this.alerta.descErr();
                this.edit5 = false;
                this.spinner.hide();
              }
            });
          } catch (e) {
            console.log(e);
          }
          // }, 600);
        }
        break;
      case 6:
        if (
          this.Medidor == undefined || this.Medidor == null ||
          this.SerialMedidor == undefined || this.SerialMedidor == null ||
          this.MarcaMedidor == undefined || this.MarcaMedidor == null ||
          this.Fotovoltaico == undefined || this.Fotovoltaico == null ||
          this.Gabinete == undefined || this.Gabinete == null ||
          this.Paneles == undefined || this.Paneles == null ||
          this.SPT == undefined || this.SPT == null ||
          this.EstadoTarjetaNFC == undefined || this.EstadoTarjetaNFC == null ||
          this.Inversor == undefined || this.Inversor == null ||
          this.ControladorCargaMPPT == undefined || this.ControladorCargaMPPT == null ||
          this.Bateria == undefined || this.Bateria == null ||
          this.Protecciones == undefined || this.Protecciones == null ||
          this.Soportes == undefined || this.Soportes == null ||
          this.TarjetaNFC == undefined || this.TarjetaNFC == null ||
          this.Instalaciones == undefined || this.Instalaciones == null
        ) {
          this.alerta.descErr("Verifique que no hayan campos vacíos");
          this.edit6 = false;
        } else {
          this.spinner.show();
          // setTimeout(() => {
          // console.log('se ejecuto lo inesperado')
          try {
            const query6 =
              "UPDATE db_liwa.Tecnico SET " +
              "medidor = " +
              "'" +
              this.Medidor +
              "'," +
              "marcaM = " +
              "'" +
              this.MarcaMedidor +
              "'," +
              "serialM = " +
              "'" +
              this.SerialMedidor +
              "'," +
              "fotovoltaico = " +
              "'" +
              this.Fotovoltaico +
              "'," +
              "estadoGabinete = " +
              "'" +
              this.Gabinete +
              "'," +
              "paneles =" +
              "'" +
              this.Paneles +
              "'," +
              "puestaTierra = " +
              "'" +
              this.SPT +
              "'," +
              "portaT = " +
              "'" +
              this.EstadoTarjetaNFC +
              "'," +
              "inversor = " +
              "'" +
              this.Inversor +
              "'," +
              "mppt = " +
              "'" +
              this.ControladorCargaMPPT +
              "'," +
              "bateria = " +
              "'" +
              this.Bateria +
              "'," +
              "protecciones = " +
              "'" +
              this.Protecciones +
              "'," +
              "instalaciones = " +
              "'" +
              this.Instalaciones +
              "'," +
              "soporte = " +
              "'" +
              this.Soportes +
              "'," +
              "nfc = " +
              "'" + this.TarjetaNFC + "'," +
              "localizacion = " +
              "'" + this.Observaciones1 + "'," +
              "observacionesF = " +
              "'" + this.Observaciones2 + "'" +
              " WHERE Id_Encuesta =" +
              "'" +
              this.idtecnico +
              "';";
            const pdata6 = { option: "insertar", texto: query6 };
            // console.log(pdata1);
            this.global.consultar(pdata6, async (err, response) => {
              // console.log(response, query);
              if ((await response)) {
                this.alerta.descValid("Los datos se actualizaron con éxito!");
                this.ngOnInit();
                this.edit6 = false;
                this.spinner.hide();
              } else if ((await response == null) || (await response == undefined)) {
                this.alerta.descErr();
                this.edit6 = false;
                this.spinner.hide();
              }
            });
          } catch (e) {
            console.log(e);
          }
          // }, 600);
        }
        break;
      case 7:
        if (this.Marca_Medidor == undefined || this.Marca_Medidor == null ||
          this.ReferenciaM == undefined || this.ReferenciaM == null ||
          this.NumMedidor == undefined || this.NumMedidor == null ||
          this.ReInicial == undefined || this.ReInicial == null
        ) {
          this.alerta.descErr("Verifique que no hayan campos vacíos");
          this.edit7 = false;
        } else {
          this.spinner.show();
          // setTimeout(() => {
          try {
            const query7 =
              "UPDATE db_liwa.Tecnico SET " +
              "marcame = " +
              "'" +
              this.Marca_Medidor +
              "'," +
              "referencia = " +
              "'" +
              this.ReferenciaM +
              "'," +
              "numero = " +
              "'" +
              this.NumMedidor +
              "'," +
              "recarga = " +
              "'" +
              this.ReInicial +
              "'" +
              " WHERE Id_Encuesta =" +
              "'" +
              this.idtecnico +
              "';";
            const pdata7 = { option: "insertar", texto: query7 };
            // console.log(pdata1);
            this.global.consultar(pdata7, async (err, response) => {
              // console.log(response, query);
              if ((await response)) {
                this.alerta.descValid("Los datos se actualizaron con éxito!");
                this.ngOnInit();
                this.edit7 = false;
                this.spinner.hide();
              } else if ((await response == null) || (await response == undefined)) {
                this.alerta.descErr();
                this.edit7 = false;
                this.spinner.hide();
              }
            });
          } catch (e) {
            console.log(e);
          }
          // }, 600);
        }
        break;

      default:
        break;
    }
  }

  eliminarFoto(data, foto) {
    Swal.fire({
      title: "<strong>¿Está seguro que desea eliminar la foto?</strong>",
      icon: "question",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#093579",
      cancelButtonText: "Cancelar",
      cancelButtonAriaLabel: "Thumbs up, great!",
      confirmButtonText: "Si, estoy seguro",
    }).then((result) => {
      // console.log(data, "esta es la data de la foto");
      if (result.isConfirmed) {
        // db_liwa.fotos_firma
        const query =
          "UPDATE db_liwa.Fotos_Tecnico SET IsDelete = 1 WHERE Id_FotoT  ='" +
          data +
          "' ;";
        const pdata1 = { option: "insertar3", texto: query };
        this.global.consultar(pdata1, async (err, response) => {
          if ((await err) == null && (await response) == true) {
            this.alerta.descValid("Foto eliminada correctamente");
            if (foto == 'mf1') {
              this.imgBandemf1 = false;
              this.ngOnInit();
            }
            if (foto == 'mf2') {
              this.imgBandemf2 = false;
              this.ngOnInit();
            }
            if (foto == 'mf3') {
              this.imgBandemf3 = false;
              this.ngOnInit();
            }
            if (foto == 'a1') {
              this.imgBande1 = false;
              this.ngOnInit();
            }
            if (foto == 'a2') {
              this.imgBande2 = false;
              this.ngOnInit();
            }
            if (foto == 'a3') {
              this.imgBande3 = false;
              this.ngOnInit();
            }
            if (foto == 'a4') {
              this.imgBande4 = false;
              this.ngOnInit();
            }
            if (foto == 'a5') {
              this.imgBande5 = false;
              this.ngOnInit();
            }
            if (foto == 'f1') {
              this.imgBande1f = false;
              this.ngOnInit();
            }
            if (foto == 'f2') {
              this.imgBande2f = false;
              this.ngOnInit();
            }
            if (foto == 'f3') {
              this.imgBande3f = false;
              this.ngOnInit();
            }
            if (foto == 'f4') {
              this.imgBande4f = false;
              this.ngOnInit();
            }
            if (foto == 'f5') {
              this.imgBande5f = false;
              this.ngOnInit();
            }
            if (foto == 'f6') {
              this.imgBande6f = false;
              this.ngOnInit();
            }
          } else {
            this.alerta.descErr("Oops, hubo un error. Verifique nuevamente");
            this.ngOnInit();
          }
        });
      } else {
        // this.ngOnInit();
      }
    });
  }

  eliminarFotoFirma(data) {
    Swal.fire({
      title: "<strong>¿Está seguro que desea eliminar la foto?</strong>",
      icon: "question",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#093579",
      cancelButtonText: "Cancelar",
      cancelButtonAriaLabel: "Thumbs up, great!",
      confirmButtonText: "Si, estoy seguro",
    }).then((result) => {
      // console.log(data, "esta es la data de la foto");
      if (result.isConfirmed) {
        // db_liwa.fotos_firma
        const query =
          "UPDATE db_liwa.fotos_firma SET IsDelete = 1 WHERE Id_Foto_Firma  ='" +
          data +
          "' ;";
        // console.log(query, 'query')
        const pdata1 = { option: "insertar3", texto: query };
        this.global.consultar(pdata1, async (err, response) => {
          if ((await err) == null && (await response) == true) {
            this.alerta.descValid("Foto eliminada correctamente");
            this.ngOnInit();
          } else {
            this.alerta.descErr("Oops, hubo un error. Verifique nuevamente");
            this.ngOnInit();
          }
        });
      } else {
        // this.ngOnInit();
      }
    });
  }

  exploreImg(): void {
    const inputElement: HTMLInputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.accept = 'image/*';
    inputElement.addEventListener('change', this.onFileSelected.bind(this));
    inputElement.click();
  }

  onFileSelected(event: Event): void {
    const inputElement: HTMLInputElement = <HTMLInputElement>event.target;
    if (inputElement.files && inputElement.files.length > 0) {
      const file: File = inputElement.files[0];
      this.validExt(file.name);
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.srcImg = e.target.result;
        this.evidence = true;
      };
      reader.readAsDataURL(file);
    }
  }

  validExt(filename: string): void {
    const extension = filename.split('.').pop().toLowerCase();
    this.ext = '.' + extension;
  }

  loadImg(estado: string): void {
    if (!this.evidence) {
      console.error('Error: No se ha seleccionado ninguna imagen.');
      this.alerta.descErr('Es necesario que  por favor seleccione alguna imgen');
      this.spinner.hide();
      return;
    } else {
      this.spinner.show();
      const imageName = this.idEncuestador + '-' + estado + '-' + moment().unix() + this.ext; // Coloca aquí el nombre personalizado que desees
      const idfoto = this.idEncuestador + '-' + estado + '-' + moment().unix();
      const formData: FormData = new FormData();
      formData.append('image', this.dataURItoBlob(this.srcImg), imageName);
      formData.append('nombre', imageName);
      formData.append('ruta', this.idtecnico);

      // Realiza la petición AJAX al servidor
      // Asegúrate de reemplazar la URL con la ruta correcta
      fetch('https://www.php.engenius.com.co/subir_foto_tecnicos.php', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          if (data === 'BADEXT' || data == null || data == undefined || data == '' || data == 'NULL') {
            console.error('Error: Extensión de archivo no permitida.');
            this.alerta.descErr('Error al subir la foto, verifique nuevamente');
            this.spinner.hide();
            return
          }
          console.log('Ruta de la imagen guardada:', data);

          const query = 'REPLACE INTO db_liwa.Fotos_Tecnico (Id_FotoT,Id_Encuesta,Id_Encuestador,Rutalocal,Rutaserver,Estado,Fecha,upload,edit,IsDelete,IsActive)' +
            ' VALUES (\'' +
            idfoto + '\',\'' +
            this.idtecnico + '\',\'' +
            this.idEncuestador + '\',\'' +
            "-" + '\',\'' +
            data + '\',\'' +
            estado + '\',\'' +
            moment().format("YYYY-MM-DD HH:mm:ss") + '\',\'' +
            1 + '\',\'' +
            1 + '\',\'' +
            0 + '\',\'' +
            1 + '\');';
          const pdata1 = { option: 'insertar', texto: query };
          this.global.consultar(pdata1, (err, response) => {
            console.log(response, query);
            if (response) {
              this.spinner.hide();
              this.alerta.descValid("Foto Agregada correctamente!");
              data = null;
              this.srcImg = " ";
              this.evidence = false;
              this.ngOnInit();
            } else if (response == null || response == undefined) {
              this.spinner.hide();
              this.alerta.descErr('Error, verifique nuevamente que no hayan campos vacíos');
              data = undefined;
              this.srcImg = " ";
              this.evidence = false;
              this.ngOnInit();
            }
          });

        })
        .catch(error => {
          console.error('Error al subir la imagen:', error);
          this.alerta.descErr('Error al subir la foto, verifique nuevamente ocomuniquise con soporte');
          this.spinner.hide();
        });
    }
  }

  loadImgfirma(): void {
    if (!this.evidence) {
      console.error('Error: No se ha seleccionado ninguna imagen.');
      this.alerta.descErr('Es necesario que  por favor seleccione alguna imgen');
      this.spinner.hide();
      return;
    } else {
      this.spinner.show();
      const imageName = this.idEncuestador + '-' + moment().unix() + this.ext; // Coloca aquí el nombre personalizado que desees
      const idfoto = this.idEncuestador + '-' + "f" + '-' + moment().unix();
      const formData: FormData = new FormData();
      formData.append('image', this.dataURItoBlob(this.srcImg), imageName);
      formData.append('nombre', imageName);
      formData.append('ruta', this.idtecnico);

      // Realiza la petición AJAX al servidor
      // Asegúrate de reemplazar la URL con la ruta correcta
      fetch('https://www.php.engenius.com.co/subir_foto_tecnicos_firma.php', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          if (data === 'BADEXT' || data == null || data == undefined || data == '' || data == 'NULL') {
            console.error('Error: Extensión de archivo no permitida.');
            this.alerta.descErr('Error al subir la foto, verifique nuevamente');
            this.spinner.hide();
            return
          }
          console.log('Ruta de la imagen guardada:', data);

          const query = "REPLACE INTO db_liwa.fotos_firma (Id_Foto_Firma, Id_Formulario, Rutalocal, Rutaserver, Estado, Fecha, upload, edit, IsDelete)" +
            ' VALUES (\'' +
            idfoto + '\',\'' +
            this.idtecnico + '\',\'' +
            "-" + '\',\'' +
            data + '\',\'' +
            "uploaded" + '\',\'' +
            moment().format("YYYY-MM-DD HH:mm:ss") + '\',\'' +
            1 + '\',\'' +
            0 + '\',\'' +
            0 + '\');';
          const pdata1 = { option: 'insertar', texto: query };
          this.global.consultar(pdata1, (err, response) => {
            console.log(response, query);
            if (response) {
              this.spinner.hide();
              this.alerta.descValid("Foto Agregada correctamente!");
              data = null;
              this.srcImg = " ";
              this.evidence = false;
              this.ngOnInit();
            } else if (response == null || response == undefined) {
              this.spinner.hide();
              this.alerta.descErr('Error, verifique nuevamente que no hayan campos vacíos');
              data = undefined;
              this.srcImg = " ";
              this.evidence = false;
              this.ngOnInit();
            }
          });

        })
        .catch(error => {
          console.error('Error al subir la imagen:', error);
          this.alerta.descErr('Error al subir la foto, verifique nuevamente ocomuniquise con soporte');
          this.spinner.hide();
        });
    }
  }


  dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }



}
